import { GatewayEntry } from '@ixicare/resources';
import { SortAccessor } from '../types';

export type GatewaySortAccessor = SortAccessor<GatewayEntry>;

export const gatewaySortAccessors: Record<string, GatewaySortAccessor> = {
  id: (g) => g.id,
  mac_address: (g) => g.macAddress,
  description: (g) => g.description ?? null,
  created: (g) => g.created?.getTime() ?? null,
  installation_zone: (g) => g.zone?.name ?? null,
  last_seen: (g) => g.lastSeen?.getTime() ?? null,
  state: (g) => g.billingState ?? null,
};
